import Combobox from '../../components/Combobox'
import messageResource from '../../messageResource'
import {escapeHtmlSymbols} from '../../atUtils'
import TemplateView from '../../TemplateView'
import {ItemRow} from '../../components/SearchItemList'

export default class CPCombobox extends Combobox {
    constructor({
        emptySelectionMessageKey = '',
        notFoundMessageKey = '',
        hiddenItemsCollapsedMessageKey = '',
        hiddenItemsExpandedMessageKey = '',
        emptyListMessageKey = '',
        emptySelectionId = -1,
        positionParams = null,
        onItemSelectedCb = (entity) => {},
        onListShowCb = () => {},
        onListHideCb = () => {},
        inputMaxLength,
    }) {
        super({
            hideItemPredicate: item => item.archived,
            onItemSelectedCb,
            onListShowCb,
            onListHideCb,
            hiddenItemsCollapsedMessageKey,
            hiddenItemsExpandedMessageKey,
            notFoundMessageKey,
            emptySelectionMessageKey,
            emptyListMessageKey,
            positionParams,
            emptySelectionId,
            additionalClass: "cpCombobox",
            inputMaxLength,
        })
    }

    renderMenuItem(item, tokensHighlighter, selectedItemId) {
        return new CPItemRow({
            item,
            tokensHighlighter,
            clickCallback: () => this._onItemSelected(item),
            additionalClass: selectedItemId === item.id ? 'selected' : '',
        })
    }

    renderAdditionalMenuItem(item, selectedItemId) {
        return new ItemRow({
            name: item.name,
            clickCallback: () => this._onItemSelected(item),
            additionalClass: selectedItemId === item.id ? 'selected' : '',
        })
    }

    renderSelectedItemHtml(item) {
        return escapeHtmlSymbols(item.name) +
               (item.archived ? " <span class='archived'>" + messageResource.getMessage("common.archived") + "</span>" : "")
    }

}

class CPItemRow extends TemplateView {
    constructor({
        item,
        tokensHighlighter,
        clickCallback = () => {},
        additionalClass = '',
    }) {
        super()

        this.params = {
            item,
            tokensHighlighter,
            clickCallback,
            additionalClass,
        }
    }

    templateHtml() {
        return '<div class="itemRow cpItemRow <%-additionalClass%>"><%=name%></div>'
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
            name: this.params.tokensHighlighter.highlightTokens(this.params.item.name) +
                  (this.params.item.archived ? " <span class='archived'>" + messageResource.getMessage("common.archived") + "</span>" : "")
        }
    }

    afterRender() {
        this.$el.click(() => this.params.clickCallback())
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/components/CPCombobox.js